import type { IconSvgObject } from './types';

const ChartIcon: IconSvgObject = [
  ["path", { d: "M14 3H10C9.44772 3 9 3.44772 9 4V21H15V4C15 3.44772 14.5523 3 14 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 8H15V21H20C20.5523 21 21 20.5523 21 20V9C21 8.44772 20.5523 8 20 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 13H4C3.44772 13 3 13.4477 3 14V20C3 20.5523 3.44772 21 4 21H9V13Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ChartIcon;
